import { Box, Grid, Typography, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";

const MiddleNavbar = () => {
  const navigate = useNavigate();
  return (
    <>
      <Box sx={{ padding: "16px" }}>
        <Grid container>
          <Grid item xs={4}>
            <Link href="https://hkust.edu.hk/">
              <img
                src={process.env.PUBLIC_URL + "/Images/HKUST_Logo2.png"}
                alt="HKUST Logo"
                width="80%"
              />
            </Link>
          </Grid>
          <Grid
            item
            xs={6}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography fontSize="24px">The Delina Research Group</Typography>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={process.env.PUBLIC_URL + "/Images/Icons/SearchIcon.png"}
              style={{ cursor: "pointer" }}
              alt="Search"
              width="24px"
              onClick={() => navigate("/publications")}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default MiddleNavbar;
